function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineComponent, toRefs, reactive, openBlock, createBlock, normalizeProps, guardReactiveProps, withCtx, createVNode, mergeProps, renderSlot, Teleport, Transition, createCommentVNode, createElementBlock, Fragment } from 'vue';
import { pick } from 'lodash-unified';
import { tooltipV2ArrowProps } from './arrow.mjs';
import { tooltipV2ContentProps } from './content.mjs';
import { tooltipV2RootProps } from './root.mjs';
import { tooltipV2Props } from './tooltip.mjs';
import { tooltipV2TriggerProps } from './trigger.mjs';
import TooltipV2Root from './root2.mjs';
import TooltipV2Arrow from './arrow2.mjs';
import TooltipV2Content from './content2.mjs';
import TooltipV2Trigger from './trigger2.mjs';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.mjs';
const __default__ = defineComponent({
  name: "ElTooltipV2"
});
const _sfc_main = /* @__PURE__ */defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: tooltipV2Props,
  setup(__props) {
    const props = __props;
    const refedProps = toRefs(props);
    const arrowProps = reactive(pick(refedProps, Object.keys(tooltipV2ArrowProps)));
    const contentProps = reactive(pick(refedProps, Object.keys(tooltipV2ContentProps)));
    const rootProps = reactive(pick(refedProps, Object.keys(tooltipV2RootProps)));
    const triggerProps = reactive(pick(refedProps, Object.keys(tooltipV2TriggerProps)));
    return (_ctx, _cache) => {
      return openBlock(), createBlock(TooltipV2Root, normalizeProps(guardReactiveProps(rootProps)), {
        default: withCtx(_ref => {
          let open = _ref.open;
          return [createVNode(TooltipV2Trigger, mergeProps(triggerProps, {
            nowrap: ""
          }), {
            default: withCtx(() => [renderSlot(_ctx.$slots, "trigger")]),
            _: 3
          }, 16), (openBlock(), createBlock(Teleport, {
            to: _ctx.to,
            disabled: !_ctx.teleported
          }, [_ctx.fullTransition ? (openBlock(), createBlock(Transition, normalizeProps(mergeProps({
            key: 0
          }, _ctx.transitionProps)), {
            default: withCtx(() => [_ctx.alwaysOn || open ? (openBlock(), createBlock(TooltipV2Content, normalizeProps(mergeProps({
              key: 0
            }, contentProps)), {
              arrow: withCtx(_ref2 => {
                let style = _ref2.style,
                  side = _ref2.side;
                return [_ctx.showArrow ? (openBlock(), createBlock(TooltipV2Arrow, mergeProps({
                  key: 0
                }, arrowProps, {
                  style,
                  side
                }), null, 16, ["style", "side"])) : createCommentVNode("v-if", true)];
              }),
              default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
              _: 3
            }, 16)) : createCommentVNode("v-if", true)]),
            _: 2
          }, 1040)) : (openBlock(), createElementBlock(Fragment, {
            key: 1
          }, [_ctx.alwaysOn || open ? (openBlock(), createBlock(TooltipV2Content, normalizeProps(mergeProps({
            key: 0
          }, contentProps)), {
            arrow: withCtx(_ref3 => {
              let style = _ref3.style,
                side = _ref3.side;
              return [_ctx.showArrow ? (openBlock(), createBlock(TooltipV2Arrow, mergeProps({
                key: 0
              }, arrowProps, {
                style,
                side
              }), null, 16, ["style", "side"])) : createCommentVNode("v-if", true)];
            }),
            default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
            _: 3
          }, 16)) : createCommentVNode("v-if", true)], 64))], 8, ["to", "disabled"]))];
        }),
        _: 3
      }, 16);
    };
  }
}));
var TooltipV2 = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "tooltip.vue"]]);
export { TooltipV2 as default };